/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { func, object, string, bool, arrayOf, objectOf, any } from 'prop-types';
import { connect, useSelector, useDispatch } from 'react-redux';
import { get, isEmpty, every, isNil } from 'lodash';
import Notification from '../../atoms/stock-notifications';
import { slugify } from '../../../helpers/utils';
import {
  BQ_STOCK_NOTIFICATIONS_DISABLE,
  SHOW_LOADER,
  REMOVE_LOADER,
  BQ_STOCK_ALREADY_ADDED,
  BQ_NOTIFICATION_LIST, NP_STOCK_WATCHLIST_GET_WATCHLISTS, NP_STOCK_WATCHLIST_GET_WATCHLISTS_DATA
} from '../../../../store/actions';
import SvgIcon from '../../atoms/svg-icon';
import { getSSOLoginUrl, getSSORedirectUrl } from '../../../helpers/subscription-helper';
import { deleteFromWatchlist, saveWatchlist, saveWatchlistStock } from '../../molecules/watchlist/watchlist-api-helper';
import {
  toastDeleteStock,
  toastStock
} from '../../molecules/watchlist/watchlist-toast-helper';
import './market-box.module.css';

const getAllDirClassName = (val, upClass = '', downClass = '', defaultClass = '') => {
  if (val > 0) return upClass;
  if (val < 0) return downClass;
  return defaultClass;
};

const Tile = ({ item, stockNotification, stockStatus, failure, userData }) => {
  const dispatch = useDispatch();
  const [redirectUrl, setRedirectUrl] = useState('');
  const [loginUrl, setLoginUrl] = useState('');
  const [showHidePlusIcon, setShowHidePlusIcon] = useState(true);
  const [undoDelete, setUndoDelete] = useState({});
  const watchlist = useSelector(state => get(state, ['watchlist'], {}));
  const SSO_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'sso'], {})
  );
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null)
  );
  const WATCHLIST_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'watchlist'], {})
  );

  const userId = userData?.userProfile?.email || userData?.userProfile?.mobile;
  const stockName = item.type !== 'stock' ? item.name : item?.nseCode && item?.nseCode?.toUpperCase() !== "NULL"? item?.nseCode : item.alias || item.name;
  const type = item?.isin?.startsWith('IN') ? 'stocks' : 'indices';

  useEffect(() => {
    const url = new URL(window?.location?.href);
    getSSORedirectUrl(url).then((pageUrl) => {
      setRedirectUrl(pageUrl);
    });
  }, []);
  useEffect(() => {
    getSSOLoginUrl(
      SSO_CONFIG.client_id,
      SSO_CONFIG.client_secret,
      redirectUrl,
      SSO_LOGIN_URL
    ).then((pageUrl) => {
      setLoginUrl(pageUrl);
    });
  }, [redirectUrl]);
  useEffect(() => {
    if (!isEmpty(undoDelete)) {
      clickOnPlusIcon(true);
      setUndoDelete({});
    }
  }, [undoDelete]);
  useEffect(() => {
    const stock = watchlist?.watchlistData?.[type]?.find(r => (r?.nse && r?.nse?.exchangeSymbol && r?.nse?.exchangeSymbol === stockName) || (r?.bse && r?.bse?.exchangeSymbol && r?.bse?.exchangeSymbol === stockName));
    if (!!stock) {
      setShowHidePlusIcon(false);
    }
  }, [watchlist]);

  const entityRedirect =
    item.type !== 'stock' ? '/markets' : `/stock/${item.stockId}/${slugify(item.name)}`;
  const tileClass =
    item.name === 'Dollar - Rupee'
      ? getAllDirClassName(item.chg, 'negative', 'positive')
      : getAllDirClassName(item.chg, 'positive', 'negative');

  const clickOnPlusIcon = (fromToast = false) => {
    if (userData && !userData?.isLoggedIn) {
      window.open(loginUrl, '_self');
    } else if (userData && userData?.isLoggedIn && (showHidePlusIcon || fromToast)) {
      let indiceType;
      if (stockName.toLowerCase().includes('nifty' || 'nse')) {
        indiceType = 'nse';
      } else {
        indiceType = 'bse';
      }

      const exchangeId = type === 'indices' ? indiceType === 'nse' ? 1 : 2 : undefined;
      if (watchlist?.watchlists?.find(w => w.name === type)) {
        saveToWatchlist(watchlist?.watchlists?.find(w => w.name === type).id, {isin: item?.isin || item?.name, exchangeId}, type);
      } else {
        saveWatchlist(userId, type)
          .then(res => {
            if (res.length > 0) {
              dispatch({ type: NP_STOCK_WATCHLIST_GET_WATCHLISTS, payload: [...watchlist?.watchlists, ...res] })
              const id = res.find(r => r.name === type)?.id;
              saveToWatchlist(id, {isin: item?.isin || item?.name, exchangeId}, type);
            } else {
              toastStock('', WATCHLIST_CONFIG.toast_messages.error_message, 'big-text');
            }
          });
      }
    }
  };

  const saveToWatchlist = (id, stock, listName) => {
    saveWatchlistStock(id, stock, listName)
      .then(res => {
        if (res.length > 0 && res.find(r => r?.isin === stock.isin || r?.name === stock.name)) {
          dispatch({ type: NP_STOCK_WATCHLIST_GET_WATCHLISTS_DATA, payload: { ...watchlist?.watchlistData, [listName]: res } });
          toastStock(stockName, WATCHLIST_CONFIG.toast_messages.stock_added);
          setShowHidePlusIcon(false);
        } else {
          toastStock('', WATCHLIST_CONFIG.toast_messages.error_message, 'big-text');
        }
      });
  }

  const clickOnCrossIcon = (showToast = true) => {
    const watchlistId = watchlist?.watchlists?.find(w => w.name === type)?.id;
    deleteFromWatchlist(watchlistId, item?.isin || item?.name)
      .then(res => {
        if (showToast) {
          if (res.status) {
            const updatedList = watchlist?.watchlistData?.[type].filter(t =>
              type === 'stocks' ? t.isin !== item.isin : t?.nse?.exchangeSymbol !== item?.nse?.exchangeSymbol && t?.exchangeSymbol !== item?.exchangeSymbol
            );
            dispatch({ type: NP_STOCK_WATCHLIST_GET_WATCHLISTS_DATA, payload: { ...watchlist?.watchlistData, [type]: updatedList } })
            setShowHidePlusIcon(true);
            toastDeleteStock(stockName, WATCHLIST_CONFIG.toast_messages.stock_deleted, setUndoDelete, true, null);
          } else {
            toastStock('', WATCHLIST_CONFIG.toast_messages.error_message, 'big-text');
          }
        }
      });
  };

  return (
    <>
      <div styleName={`tile ${tileClass}`}>
        <a href={entityRedirect}>
          <div styleName="inner-tile">
            <span className="truncate-overflow">{stockName}</span>
            {item.value ? (
              <span style={{ color: item.chgp > 0 ? 'var(--success-color)' : 'var(--negative-red)' }}>
                {Number(item.value).toFixed(2)}
                <SvgIcon
                  type={`${item.chgp > 0 ? 'upArrowCircle' : 'downArrowCircle'}`}
                  source="image"
                  height="13"
                  width="13"
                />
              </span>
            ) : (
              '-'
            )}
            {item.value ? (
              <span styleName="">
                {item.chgp > 0 ? `+${Number(item.chgp).toFixed(2)}` : Number(item.chgp).toFixed(2)}%
              </span>
            ) : (
              <span>No Data Available</span>
            )}
          </div>
        </a>
        {showHidePlusIcon ? (
          <div styleName="plus-sign" onClick={() => clickOnPlusIcon()}>
            <span styleName="plus-sign-inner"></span>
          </div>
        ) : (
          <div styleName="close-ctx" onClick={() => clickOnCrossIcon()}>
            <div styleName="close-button"></div>
          </div>
        )}
      </div>

      {stockNotification && (
        <Notification message={stockNotification} stockStatus={stockStatus} failure={failure} />
      )}
    </>
  );
};

Tile.propTypes = {
  item: objectOf(any).isRequired,
  checkUserLoggedIn: func,
  stockNotification: string,
  stockStatus: string,
  failure: bool,
  loggedIn: bool,
};

class MarketBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entities: [],
      selectedItem: '',
    };
  }

  componentDidMount() {
    const entityIds = this.props.entities
      .slice(0, 4)
      .map((entity) => entity.id)
      .join(',');
    this.getEntityDetails(entityIds);
    this.marketBoxRefreshInterval = setInterval(this.getEntityDetails.bind(this, entityIds), 60000);
  }

  componentWillUnmount() {
    if (this.marketBoxRefreshInterval) clearInterval(this.marketBoxRefreshInterval);
  }

  updateMember = async (member) => {
    await this.props.reloadMember(member);
  };

  getEntityDetails = (params) => {
    fetch(`/next/feapi/stock?entity-ids=${params}`)
      .then((response) => response.json())
      .then((entities) => {
        let values = [];
        const isValid = every(entities, value => !isNil(value));
        if (isValid) {
          values = entities;
        }
        this.setState({ entities: values });
      })
      .catch(() => this.setState({ entities: [] }));
  };

  render() {
    return this.state.entities.length ? (
      <div styleName={`container`}>
        {this.state.entities.map((entity) => (
          <Tile
            item={entity}
            key={entity.name}
            stockNotification={this.props.stockNotification}
            stockStatus={this.props.stockStatus}
            failure={this.props.failure}
            userData={this.props.userData}
          />
        ))}
      </div>
    ) : (
      <div />
    );
  }
}

MarketBox.propTypes = {
  entities: arrayOf(object).isRequired,
  showLoader: func,
  removeLoader: func,
  maxStock: object,
  getStocksFromFirebase: func,
  stockNotification: string,
  stocks: object,
  showNotification: func,
  userLoggedIn: bool,
  publicIntegrations: object.isRequired,
  integrations: object.isRequired,
  reloadMember: func,
  subscriptionStatus: string,
  stockStatus: string,
  failure: bool,
};

const mapStateToProps = (state) => {
  return {
    maxStock: get(state, ['qt', 'config', 'features', 'stock_watchlist_tab', 'max_stock'], {}),
    stocks: get(state, ['userDetails', 'stockWatchList', 'stocks'], {}),
    stockNotification: get(state, ['userDetails', 'stockNotification'], null),
    subscriptionStatus: get(state, ['userDetails', 'subscriptionStatus'], null),
    publicIntegrations: state.qt.config['public-integrations'] || {},
    integrations: state.qt.config.integrations || {},
    stockStatus: get(state, ['userDetails', 'stockStatus'], null),
    failure: get(state, ['userDetails', 'failure'], null),
    userData: get(state, ['userData'], {}),
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    showNotification: (message) => {
      dispatch({
        type: BQ_STOCK_ALREADY_ADDED,
        payload: {
          message: [message],
        },
      });
      dispatch({
        type: BQ_NOTIFICATION_LIST,
        payload: {
          notification: setTimeout(() => {
            dispatch({ type: BQ_STOCK_NOTIFICATIONS_DISABLE });
          }, 3000),
        },
      });
    },
    showLoader: () => {
      dispatch({
        type: SHOW_LOADER,
      });
    },
    removeLoader: () => {
      dispatch({
        type: REMOVE_LOADER,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketBox);
